import React from "react";
import Layout from "../Shared/Layout";
import {Container, Grid, Paper} from "@material-ui/core";
import {InertiaLink} from "@inertiajs/inertia-react";
import AccordionList from "../Shared/AccordionList";
import {Trans} from "../utils/i18n";
import TrackIcon2 from "../Shared/Icons/TrackIcon2";
import Appointment from "../Shared/Icons/AppointmentIcon";
import SelfHelpIcon2 from "../Shared/Icons/SelfHelpIcon2";
import SelfServiceIcon2 from "../Shared/Icons/SelfServiceIcon2";
import PartsShopIcon from "../Shared/Icons/PartsShopIcon";

export default function HomeDemoB2B({languages, currentLanguage, faqs, client}) {
    return (
        <div className={"-mt-12 bgcolor"}>
            <div
                className={`w-full bg-pattern bg-center bg-no-repeat bg-cover p-2  py-16 min-h-[300px]`}
                style={{backgroundImage: `url(${client.home_banner})`}}
            >
                <div className={`lg:mx-auto max-w-[2200px] relative`}>
                    <Container maxWidth="lg">
                        <h1
                            className={
                                "text-center text-header-icons text-5xl font-bold"
                            }
                        >
                            <Trans i18nKey={"welcome.portalSolutions"}>
                                Portal Solutions
                            </Trans>
                        </h1>
                    </Container>
                </div>
            </div>
            <Container maxWidth="lg">
                <div className={"relative"}>
                    <div
                        className={
                            "mx-auto mt-20 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl"
                        }
                    >
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center box"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px]"
                                }
                            >
                                <SelfHelpIcon2 className={"w-40 h-32 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('selfrepair.guides.index')}
                                        className={
                                            "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.selfHelp"
                                            }
                                        >
                                            Self-Help
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <SelfServiceIcon2 className={"w-40 h-32 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('order')}
                                        className={
                                            "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.selfService"
                                            }
                                        >
                                            Self-Service
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <Appointment className={"w-40 h-32 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('track.index')}
                                        className={
                                            "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.appointment"
                                            }
                                        >
                                            Make appointment
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"relative"}>
                    <div
                        className={
                            "mx-auto mt-10 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl"
                        }
                    >
                        <div
                            className={
                                "col-span-12 md:col-span-6 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <PartsShopIcon className={"w-40 h-32 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('track.index')}
                                        className={
                                            "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.shop"
                                            }
                                        >
                                            Accessory Web Shop
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-6 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <TrackIcon2 className={"w-40 h-32 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('track.index')}
                                        className={
                                            "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.trackTrace"
                                            }
                                        >
                                            Track & Trace
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {faqs.length > 0 && (
                    <div className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <>
                            <h2
                                className={
                                    "text-center text-2xl font-bold mb-0 mt-8"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.title"}>
                                    FAQs & Troubleshooting Guides
                                </Trans>
                            </h2>
                            <p
                                className={
                                    "text-center text-md font-medium mt-4"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.subtitle"}>
                                    All you need to know about our service offer
                                </Trans>
                            </p>
                            <div className="w-11/12">
                                <AccordionList items={faqs}/>
                            </div>
                        </>
                        <p className={"text-center mt-3 mb-8 pt-8"}>
                            <InertiaLink
                                className={" block font-bold text-secondary"}
                                href={route("faq")}
                            >
                                <Trans i18nKey={"welcome.checkAllResources"}>Check all the resources</Trans>
                            </InertiaLink>
                        </p>
                    </div>
                )}

                {/* {
                    <div
                        className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <h2
                            className={
                                "text-center text-2xl font-bold mb-0 mt-8"
                            }
                        >
                            <Trans i18nKey={"welcome.whitelabel.need_help"}>
                                Need help?
                            </Trans>
                        </h2>
                        <p className={"text-center text-md font-medium mt-4"}>
                            <Trans i18nKey={"welcome.whitelabel.need_help_descrption"}>
                                For further assistance please feel free to chat with us.
                            </Trans>
                        </p>
                        <p className={"text-center mt-3 mb-8"}>
                            <InertiaLink
                                className={
                                    "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                }
                                href={route("contact")}
                            >
                                <Trans i18nKey={"welcome.checkResources"}>
                                    Check resources
                                </Trans>
                            </InertiaLink>
                        </p>
                    </div>
                } */}
            </Container>
        </div>
    );
}

HomeDemoB2B.layout = (page) => <Layout children={page}/>;
